var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.initialized)?_c('div',[_c('ReportBuilderFilters',{staticClass:"mb-4",on:{"filtersApplied":_vm.refreshReports,"preloaded":function($event){_vm.loading = false}}}),_c('ReportSection',{attrs:{"loading":_vm.loading}})],1):_c('div',[_c('FullLoader')],1),_c('OptionsDrawer',{on:{"metricsUpdated":_vm.refreshReports}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }